export default __webpack_public_path__ + "static/media/underline.5c71a92d.png";